const getDeepKeyPath = (field: string) => {
  const split = field.split(/\[([^[]*)]/g)
  return split.filter((val) => !!val)
}

export default getDeepKeyPath
